var questionTrace = [];

function initialiseQuiz( )
{   
    //sets all the event listeners
    landingPageEl( );
    answerCardEl( );
    prevQuestion( );
    nextQuestion( );
    selectAnswer( );
    console.log( "Product quiz started." )
}

function landingPageEl ( )
{
    document.querySelector( ".landing-page__text__button" ).addEventListener( "click", function( )
    {
        document.querySelector( ".product-quiz__landing-page" ).style.display = "none";
        var firstQuestion = document.querySelector( ".product-quiz__question.first-question " );
        if ( firstQuestion )
        {
            firstQuestion.classList.remove( "product-quiz__question--collapsed" );
            questionTrace.push( firstQuestion.dataset.questionKey );
        }
    });
}

function answerCardEl( )
{
    var cards = document.querySelectorAll( ".answer-card" );
    for ( var i = 0; i < cards.length; i ++ )
    {
        cards[ i ].addEventListener( "click", function ( )
        {
            var parentEl = this.parentElement;
            parentEl.querySelectorAll( ".answer-card" ).forEach( card =>
            {
                card.classList.remove( "answer-card--selected" );
            });
            this.classList.add( "answer-card--selected" );

            // If it's the first question, add the question key to the trace
            if ( questionTrace.length === 0 )
            {
                var firstKey = this.dataset.currentQuestion;
                if ( firstKey !== "" )
                {
                    questionTrace.push( firstKey );
                }
            }
        });
    }
}

function nextQuestion( )
{
    var nextQuestionButtons = document.querySelectorAll( ".next-question" );
    for ( var i = 0; i < nextQuestionButtons.length; i ++ )
    {
        nextQuestionButtons[ i ].addEventListener( "click", function ( )
        {
            var currQuestion = document.querySelector( `[data-question-key="${ this.dataset.currentQuestion }"]` );
            var selectedCard = currQuestion.querySelector( ".answer-card--selected" );
            if ( selectedCard != null && currQuestion.dataset.questionKey == questionTrace[ questionTrace.length - 1 ] )
            {
                var nextQuestionKey = selectedCard.dataset.nextQuestion;
                if ( nextQuestionKey === "" )
                {
                    document.querySelector( ".progress__bar__fill" ).style.width = "100%";
                    var url = selectedCard.dataset.resultPage;
                    showResults( url );
                    return;
                }
                var nextQuestion = document.querySelector( `[data-question-key="${ nextQuestionKey }"]` );
                if ( nextQuestion != null && !questionTrace.includes( nextQuestionKey ) )
                {
                    currQuestion.classList.add( "product-quiz__question--collapsed" );

                    nextQuestion.classList.remove( "product-quiz__question--collapsed" );
                    questionTrace.push( nextQuestionKey );
                    document.querySelectorAll( ".product-quiz__back" ).forEach( backButton =>
                    {
                        backButton.dataset.currentQuestion = nextQuestionKey;
                    });
                    updateProgressBar( nextQuestion );
                }
            }
        });
    }
}


function prevQuestion( )
{
    document.querySelectorAll( ".product-quiz__back" ).forEach( backButton =>
    {
        backButton.addEventListener( "click", function( e )
        {
            if ( questionTrace.length === 0 )
            {
                history.back( );
            }
            if ( questionTrace.length === 1 )
            {
                document.querySelector( ".product-quiz__landing-page" ).style.display = "";
                document.querySelector( ".product-quiz__question.first-question" ).classList.add( "product-quiz__question--collapsed" );
                document.querySelector( ".progress__bar__fill" ).style.width = `3%`
                questionTrace.splice( questionTrace[ 0 ], 1 );
            }
            else if ( questionTrace.length > 1 )
            {
                goToPrevQuestion( e );
                this.dataset.currentQuestion = questionTrace[ questionTrace.length - 1 ];
            }
        });
    });
}

function goToPrevQuestion( e )
{
    if ( questionTrace.length > 1 )
    {
        var currQuestion = document.querySelector( `[data-question-key="${ e.target.dataset.currentQuestion }"]` );
        var answersContainer = currQuestion.querySelector( ".question__answers" );
        clearAnswers( answersContainer );
        const index = questionTrace.indexOf( currQuestion.dataset.questionKey );
        if ( index > -1 && index == questionTrace.length - 1 )
        {
            questionTrace.splice( index, 1 );
        }
        var prevQuestionKey = questionTrace[ questionTrace.length - 1 ];
        var prevQuestion = document.querySelector( `[data-question-key="${ prevQuestionKey }"]` )

        currQuestion.classList.add( "product-quiz__question--collapsed" );
        prevQuestion.classList.remove( "product-quiz__question--collapsed" );

        updateProgressBar( prevQuestion );
    }
}

function selectAnswer( )
{
    var selects = document.querySelectorAll( ".answer-card" );
    selects.forEach( ( select ) =>
    {
        select.addEventListener( "click", function( )
        {
            this.parentElement.parentElement.querySelector( ".next-question" ).disabled = false;
        });
    });
}

function clearAnswers( answersContainer )
{
    cards = answersContainer.querySelectorAll( ".answer-card" );
    cards.forEach( card =>
    {
        if ( card.classList.contains( "answer-card--selected" ) )
        {
            card.classList.remove( "answer-card--selected" );
        }
    });
    answersContainer.dataset.selectedValue = "";
    answersContainer.parentElement.querySelector( ".next-question" ).disabled = true;
}

function updateProgressBar( nextQuestionEl )
{
    var longestPossibleFlow = getLongestQuestionFlow( nextQuestionEl );
    //getLongestPossibleFlow omits the question as its parameter from the calculation
    //and the questiontrace includes the same question so no need for +1
    var totalQuestions = questionTrace.length + longestPossibleFlow;
    if ( questionTrace.length - 1 === 0 )
    {
        document.querySelector( ".progress__bar__fill" ).style.width = "3%";
    }
    else
    {
        document.querySelector( ".progress__bar__fill" ).style.width = `${ ( questionTrace.length - 1 ) / totalQuestions * 100 }%`
    }
}

function showResults( url ) {
  
    if ( url )
    {
        document.querySelector( ".quiz-loading" ).style.display = "flex";
        const quizQuestions = document.querySelector( ".product-quiz__questions" );
        quizQuestions.classList.add( "fade-out" );

        setTimeout( ( ) =>
        {
            window.location.href = url;
        }, 600 );
    }
    else
    {
        alert( "No results for this flow." );
    }
}


//function to find the longest question flow from the parameter question
//excludes the question it is called with
function getLongestQuestionFlow( question )
{
    var highest = 0;

    question.querySelectorAll( ".answer-card" ).forEach( answerCardEl =>
    {
        if ( answerCardEl.dataset.nextQuestion != "" )
        {
            var nextHighest = 1;
            var childHighest =  getLongestQuestionFlow( document.querySelector( `[data-question-key="${ answerCardEl.dataset.nextQuestion }"]` ) );
            nextHighest = nextHighest + childHighest;
            if ( nextHighest > highest )
            {
                highest = nextHighest;
            }
        }
    });

    return highest;
}

initialiseQuiz( );